import { Component, Optional } from '@angular/core';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { DynamicFormService } from '@ntap/common';
import {
  ActionComponentNew,
  ActionResult,
  DataSource,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  ViewWindow
} from '@ntap/core';
import {
  catchError,
  combineLatest,
  EMPTY,
  first,
  map,
  mergeMap,
  Observable,
  tap
} from 'rxjs';
import { PremjestiService } from '../premjesti-action/premjesti.service';

@Component({
  selector: 'app-potvrdi-premjestanje-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./potvrdi-premjestanje-action.component.scss']
})
export class PotvrdiPremjestanjeActionComponent extends ActionComponentNew<ActionResult> {
  constructor(
    protected listViewProvider: ListViewProviderDirective<ListView>,
    notificationService: NotificationService,
    @Optional() protected window: ViewWindow,
    protected dataSource: DataSource,
    protected parentListView: ParentListViewProvider,
    protected formService: DynamicFormService,
    protected premjestajComplete: PremjestiService
  ) {
    super(notificationService);
    if (this.window) {
      this.addSubscription(
        this.result$.subscribe(
          (result) => Object.keys(result).length > 0 && this.closeWindow()
        )
      );
    }
  }

  protected override initDisabledObservable(): void {
    this.isDisabled$ = combineLatest([
      this.listViewProvider.selectedItems$,
      this.listViewProvider.selectAll$,
      this.premjestajComplete.rootSelected$,
      this.premjestajComplete.loading$,
      this.premjestajComplete.batchMode$
    ]).pipe(
      map(([selectedItems, selectAll, rootSelected, loading, batchMode]) => {
        if (loading || selectAll) {
          return true;
        }
        if (!selectedItems) {
          return true;
        }
        const rootHasValue =
          rootSelected && Object.keys(rootSelected).length > 0;
        if (batchMode) {
          return !(selectedItems.length >= 1 || rootHasValue);
        }
        return selectedItems.length != 1;
      })
    );
  }

  protected doExecute(): Observable<ActionResult> {
    const isBatchMode = this.premjestajComplete.batchMode$.getValue();

    return this.getActionParams().pipe(
      mergeMap((params) => {
        return this.dataSource.executeAction(this.action.name, params).pipe(
          tap(() => {
            this.parentListView.refresh();
            this.premjestajComplete.openPremjestanjeDialog(false);
          }),
          catchError((err) => {
            if (isBatchMode) {
              this.notificationService.error(err);
              return EMPTY;
            }
            throw err;
          })
        );
      })
    );
  }

  private closeWindow() {
    this.window.close();
  }

  getActionParams() {
    return combineLatest([
      this.listViewProvider.selectedItems$,
      this.parentListView.selectedItems$,
      this.premjestajComplete.premjestajData$
    ])
      .pipe(
        map(([selectedTargets, selectedSources, premjestajData]) => {
          return {
            $selected: selectedSources,
            $selectedTargets: selectedTargets,
            $redoslijed: premjestajData.$redoslijed
          };
        })
      )
      .pipe(first());
  }
}
